import { Box } from '@hivebrite/design-system/Box';
import { Card } from '@hivebrite/design-system/Card';
import { Skeleton } from '@hivebrite/design-system/Skeleton';

const CardPinnedLoader = () => (
  <Card height="188px" width="100%" p={4}>
    <Skeleton height={40} width="100%" />
    <Box display="block" py={2}>
      <Skeleton height={90} width="100%" />
    </Box>
  </Card>
);

export default CardPinnedLoader;
